import React, { useEffect, useState } from 'react'
import { Search, X, Star } from 'lucide-react'
import './MarketPage.css'
import './MarketRedesign.css'
import UTI from './UTI'
import MarketOverview from './MarketOverview'

const MARKET_TABS = [
  { key: 'usdt', label: 'Spot', placeholder: 'Search pairs' },
  { key: 'futures', label: 'Futures', placeholder: 'Search perpetual' },
  { key: 'favorites', label: 'Favorites', placeholder: 'Search fav', icon: Star },
]

const MarketPage = () => {
  const [marketType, setMarketType] = useState('usdt')
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(search.trim()), 350)
    return () => clearTimeout(timer)
  }, [search])

  const activeTab = MARKET_TABS.find((t) => t.key === marketType) || MARKET_TABS[0]

  return (
    <section className='mk-page text-light'>
      <div className='container pt-4 pb-5'>
        <header className='mk-header'>
          <h1 className='mk-title'>
            Crypto <span className='mk-gradient'>Markets</span>
          </h1>
          <p className='mk-subtitle'>
            Track prices, trends and top movers on Unitic Exchange.
          </p>
        </header>

        <MarketOverview />

        <div className='mk-section-head'>
          <h2 className='mk-section-title'>All Markets</h2>
        </div>

        <div className='mk-toolbar'>
          <div className='mk-tabs' role='tablist'>
            {MARKET_TABS.map((tab) => {
              const Icon = tab.icon
              const active = marketType === tab.key
              return (
                <button
                  key={tab.key}
                  type='button'
                  role='tab'
                  aria-selected={active}
                  className={`mk-tab ${active ? 'active' : ''}`}
                  onClick={() => setMarketType(tab.key)}
                >
                  {Icon && <Icon size={14} />}
                  {tab.label}
                </button>
              )
            })}
          </div>

          <div className='mk-search'>
            <Search size={16} className='mk-search-icon' />
            <input
              type='text'
              className='mk-search-input'
              placeholder={activeTab.placeholder}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {search && (
              <button
                type='button'
                className='mk-search-clear'
                aria-label='Clear search'
                onClick={() => setSearch('')}
              >
                <X size={14} />
              </button>
            )}
          </div>
        </div>

        <UTI marketType={marketType} search={debouncedSearch} />
      </div>
    </section>
  )
}

export default MarketPage